import React from "react";
import { Configurable } from "./Configurable";
import { AppearanceCheckbox } from "./fields/AppearanceCheckbox";
import { AppearanceSlider } from "./fields/AppearanceSlider";
import { AppearanceText } from "./fields/AppearanceText";

/**
 * Applies readonly to input field
 */
export class ReadOnly extends Configurable {
    public schema;
    public designer;
    public field;
    public defaultValue = false;

    public keyName = "readonly";
    public title = "ReadOnly";
    public description = "Ist dieses Feld nur lesbar?";
    public value = "";

    public EditComponent({
        register,
        schema,
        designer,
        field,
    }: {
        register: any;
        schema: any;
        designer: any;
        field: any;
    }): any {
        return (
            <AppearanceCheckbox
                label="Ist dieses Feld nur lesbar?"
                register={register}
                value={field.rawOptions[this.keyName]}
                placeholder={this.title}
                field={field}
                keyName={this.keyName}
            />
        );
    }

    public sleepValue(value): any {
        return value !== false;
    }

    public configureInput(inputEl, register): any {
        if (this.value) {
            inputEl = React.cloneElement(
                inputEl,
                {
                    "readOnly": true,
                    "data-readonly": true,
                    ...inputEl.props,
                },
                inputEl.props.children
            );
            return inputEl;
        }
        return inputEl;
    }

    public wakeValue(value) {
        return value;
    }
}
